import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import Layout from '../../../layout/default';

const ReturnAndRefundPolicy = () => {
    return (
        <Layout title="Return and Refund Policy">
            <Container className="my-5">
                <Row className="justify-content-center">
                    <Col md={10} lg={8}>
                        <Card className="shadow-lg border-0">
                            <Card.Body className="p-4">
                                <Card.Title className="text-center mb-4 display-6">Grocenetmart Return and Refund Policy</Card.Title>
                                <Card.Text className="text-justify">
                                    <p className="mb-4 text-muted">
                                        At Grocenetmart, we strive to provide our customers with the best possible products and services. However, we understand that sometimes products may not meet your expectations.
                                    </p>
                                    <h5 className="mb-3">Return Policy</h5>
                                    <p className="mb-4 text-muted">
                                        If you are not satisfied with a product, you may return it within <strong>7 days of delivery</strong>. To initiate a return, please contact our customer support team at <a href="mailto:sspepvtltd10@gmail.com" className="text-decoration-none">sspepvtltd10@gmail.com</a>.
                                    </p>
                                    <h5 className="mb-3">Eligibility for Returns</h5>
                                    <ul className="mb-4 text-muted">
                                        <li>In its original packaging and condition</li>
                                        <li>Unused and unopened</li>
                                        <li>Returned within the specified time frame</li>
                                    </ul>
                                    <h5 className="mb-3">Refund Policy</h5>
                                    <p className="mb-4 text-muted">
                                        If your return is accepted, we will provide a refund of the purchase price within <strong>7-10 business days</strong>.
                                    </p>
                                    <h5 className="mb-3">Refund Methods</h5>
                                    <p className="mb-4 text-muted">
                                        Refunds will be processed using the original payment method.
                                    </p>
                                    <h5 className="mb-3">Cancellation Policy</h5>
                                    <p className="mb-4 text-muted">
                                        If you need to cancel an order, please contact our customer support team as soon as possible. We will do our best to accommodate your request, but please note that we may not be able to cancel an order once it has been processed.
                                    </p>
                                    <h5 className="mb-3">Contact Us</h5>
                                    <p className="text-muted">
                                        If you have any questions or concerns about our Return and Refund Policy, please contact our customer support team at <a href="mailto:sspepvtltd10@gmail.com" className="text-decoration-none">sspepvtltd10@gmail.com</a>.
                                    </p>
                                </Card.Text>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </Layout>
    );
};

export default ReturnAndRefundPolicy;